import { Directive, OnDestroy, OnInit } from '@angular/core';
import { PaginatedResultModel } from '@data-layer/models/common';
import { Observable, of, ReplaySubject } from 'rxjs';
import { catchError, map, takeUntil, tap } from 'rxjs/operators';
import { UtilsHelper } from '@helpers/utils-helper';

@Directive()
export abstract class PaginationDynamicComponent<T, S> implements OnInit, OnDestroy {
  public limit: number = 20;
  public total: number = 0;
  public totalRows: number = 0;
  public items: Observable<T[]>;
  public lastSearch: S;
  public isLoading: boolean = false;
  public page: number = 1;
  public itemsIds: number[];

  protected isDestroy: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  public ngOnInit(): void {
    this.getPage(1, this.limit);
  }

  public ngOnDestroy(): void {
    this.isDestroy.next(true);
    this.isDestroy.complete();
  }

  public search(filters: S) {
    this.lastSearch = filters;
    this.getPage(1, this.limit);
  }

  public getPage(page: number, limit: number) {
    const filters = this.lastSearch || {};
    this.page = page;
    this.limit = limit;
    this.isLoading = true;
    this.items = this.searchMethod({ ...filters, offset: (page - 1) * this.limit, limit: this.limit } as any as S, false).pipe(
      catchError(() =>
        of({
          options: {
            limit: this.limit,
            offset: 0,
          },
          total: 0,
          items: [],
        }),
      ),
      tap((res: PaginatedResultModel<T>) => {
        this.total = res.total;
        this.isLoading = false;
        this.totalRows = res.items.length;
        this.itemsIds = res.items.map((item: any) => item.id);
      }),
      map((res) => res.items),
      takeUntil(this.isDestroy),
    );
  }

  protected abstract searchMethod(filters: S, isShowLoader: boolean): Observable<PaginatedResultModel<T>>;

  protected searchableValue(value: any) {
    return !UtilsHelper.isNullOrUndefined(value) && value !== '';
  }
}
